export const statuses = {
  NEW: 1,
  'IN PROGRESS': 2,
  CLOSED: 3
}

export const statusesNames = {
  1: 'NEW',
  2: 'IN PROGRESS',
  3: 'CLOSED'
}

export const moduleType = {
  CLINICAL_PATHWAY: 1,
  MEASUREMENT: 2,
  MEDICATION: 3
}

export const moduleTypePatientLink = {
  1: '/patients/{:patientUuid}/clinical-pathways',
  2: '/patients/{:patientUuid}/measurements',
  3: '/patients/{:patientUuid}/medication'
}

export const moduleTypeNames = {
  0: 'INTERNAL',
  1: 'EPROMS',
  2: 'MEASUREMENT',
  3: 'MEDICATION'
}

export const moduleTypeNamesTitles = {
  1: 'Responses',
  2: 'Measurement',
  3: 'Intakes'
}

export const priorityType = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
}

export const priorityTypeNames = {
  1: 'LOW',
  2: 'MEDIUM',
  3: 'HIGH'
}

export const rowColors = {
  1: 'transparent',
  2: '#fbeadc',
  3: '#f7e3e4'
}

export const ACTIVITY_REASON_PATIENT_MONITORING_REF_VALUE =
  'General patient communication'

export const PROTOCOL_MODAL_DEFAULT_SORT = {
  sortedColumn: 'description',
  sortedColumnOrder: 'ascend'
}
